import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const CurCtx = createContext(null);

export const useCurrency = () => useContext(CurCtx);

export function CurrencyProvider({ children }) {
  const [currencies, setCurrencies] = useState([{ code: "USD", symbol: "$", rate: 1 }]);
  const [code, setCodeState] = useState(() => localStorage.getItem("simashi_currency") || "USD");

  useEffect(() => {
    api("/config")
      .then((c) => Array.isArray(c.currencies) && c.currencies.length && setCurrencies(c.currencies))
      .catch(() => {});
  }, []);

  const cur = currencies.find((c) => c.code === code) || currencies[0];

  const setCode = (c) => {
    localStorage.setItem("simashi_currency", c);
    setCodeState(c);
  };

  const fmt = (usd) => {
    if (usd === null || usd === undefined || isNaN(Number(usd))) return "";
    const v = Number(usd) * (cur?.rate || 1);
    const rounded = ["USD", "EUR", "GBP"].includes(cur?.code) ? Math.round(v * 100) / 100 : Math.round(v);
    return `${cur?.symbol || "$"}${rounded.toLocaleString()}`;
  };

  const fmtRange = (p) => {
    if (p.price_min == null && p.price_max == null) return "—";
    if (p.price_min != null && p.price_max != null && p.price_max !== p.price_min)
      return `${fmt(p.price_min)} – ${fmt(p.price_max)}`;
    return fmt(p.price_min ?? p.price_max);
  };

  return (
    <CurCtx.Provider value={{ code, setCode, currencies, fmt, fmtRange, symbol: cur?.symbol || "$" }}>
      {children}
    </CurCtx.Provider>
  );
}
